import {ApiDocs} from './components/apiDocs';

export default {
    component: ApiDocs
};
